export const css = {
    root: 'GCxaGiCX',
    scoreblock: '_3Two3N0k',
    legend: '_1HjvQNHS',
    scoreIcon: '_1kgc7IqD',
    assessIcon: '_3JIJYDEE',
    topicGroup: 'PiVJ2GDn',
    ' _key': 'afcpe-theme/afcpe/prepost-viz/prepost-viz'
};
export default css;
